module.exports = __webpack_public_path__ + "img/item1-4.80924a63.jpg";